import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { LayoutDashboard, ClipboardCheck, Users, Dumbbell, Award, LogOut, Flame, Ticket, Zap, ShoppingBag, Shield } from "lucide-react";

const items = [
    { to: "/admin", icon: LayoutDashboard, label: "Dashboard", exact: true },
    { to: "/admin/review", icon: ClipboardCheck, label: "Review" },
    { to: "/admin/quests", icon: Zap, label: "Quests" },
    { to: "/admin/shop", icon: ShoppingBag, label: "Shop" },
    { to: "/admin/users", icon: Users, label: "Users" },
    { to: "/admin/challenges", icon: Dumbbell, label: "Challenges" },
    { to: "/admin/badges", icon: Award, label: "Badges" },
    { to: "/admin/invites", icon: Ticket, label: "Invites" },
    { to: "/admin/invite-quotas", icon: Shield, label: "Quotas" },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate("/login");
    };

    return (
        <div className="min-h-screen flex flex-col lg:flex-row bg-charcoal-900">
            {/* Sidebar (desktop) / topbar (mobile) */}
            <aside className="lg:w-64 lg:border-r border-b lg:border-b-0 border-charcoal-500 bg-charcoal-800">
                <div className="p-5 flex items-center gap-2 border-b border-charcoal-500">
                    <div className="w-8 h-8 bg-neon-orange flex items-center justify-center">
                        <Flame className="text-white" size={16} />
                    </div>
                    <div>
                        <div className="font-display font-black uppercase tracking-tight text-sm">No Excuse</div>
                        <div className="label-cap text-[10px] text-neon-green">Admin</div>
                    </div>
                </div>
                <nav className="flex lg:flex-col p-2 gap-1 overflow-x-auto">
                    {items.map((it) => (
                        <NavLink
                            key={it.to}
                            to={it.to}
                            end={it.exact}
                            data-testid={`admin-nav-${it.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `shrink-0 flex items-center gap-2 px-3 py-2 label-cap text-xs transition-all ${
                                    isActive
                                        ? "bg-neon-green text-black"
                                        : "text-zinc-400 hover:text-white hover:bg-charcoal-700"
                                }`
                            }
                        >
                            <it.icon size={14} />
                            <span>{it.label}</span>
                        </NavLink>
                    ))}
                </nav>
                <div className="p-3 hidden lg:block border-t border-charcoal-500 mt-auto">
                    <div className="text-xs text-zinc-500">{user?.email}</div>
                    <button
                        onClick={handleLogout}
                        data-testid="admin-logout"
                        className="mt-2 w-full py-2 surface-1 text-neon-orange label-cap text-xs flex items-center justify-center gap-2 hover:border-neon-orange"
                    >
                        <LogOut size={12} /> Log Out
                    </button>
                </div>
            </aside>
            <main className="flex-1 p-5 lg:p-8 overflow-x-hidden">
                <Outlet />
            </main>
        </div>
    );
}
